import { render, staticRenderFns } from "./purchase.vue?vue&type=template&id=68cacd74&scoped=true&"
import script from "./purchase.vue?vue&type=script&lang=js&"
export * from "./purchase.vue?vue&type=script&lang=js&"
import style0 from "./purchase.vue?vue&type=style&index=0&id=68cacd74&scoped=true&lang=css&"
import style1 from "./purchase.vue?vue&type=style&index=1&id=68cacd74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cacd74",
  null
  
)

export default component.exports